import { defineStore  } from 'pinia'
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'
 
export const useMenuStore = defineStore('menu', {
  state: () => ({
    dishList: [],
    categoryList: []
  }),

  getters : {
    categoryAll : (state) => {
      return [{
        categoryId: 'all',
        name: '全部',
        description: '',
        icon: ''
      }].concat(state.categoryList)
    },

    categorys: (state) => {
      return state.categoryList.filter(category => category.type === 'category')
    },

    tags: (state) => {
      return state.categoryList.filter(category => category.type === 'tag')
    },

    dispalyDishList : (state) => {
      return state.dishList.filter(dish => dish.displayFlag)
    }
  },

  actions: {
    async getDishList(){
      this.dishList = []
      const res = await httpService.post(URL.DISH_RETRIEVE, {})
      const dishes = res
      this.dishList = dishes.map(d => {
        return {...d
          ,discountDateRange: [d.startDate, d.endDate]
          ,categoryName : this.categorys.find(category => category.categoryId === d.categoryId)?.name || ''
          ,tagName : this.tags.find(tag => tag.categoryId === d.tag)?.name || ''
          }
      });
    },

    async getCategoryList(){
      this.categoryList = []
      const res = await httpService.post(URL.CATEGORY_RETRIEVE, {})
      this.categoryList = res
    },

    async editDish(p){
      await httpService.post(URL.DISH_UPDATE, p)
      this.getDishList()
    },

    async deleteDish(p){
      await httpService.post(URL.DISH_DELETE, p)
      this.getDishList()
    },

    async displayChange(p){
      await httpService.post(URL.DISH_DISPLAY_UPDATE, p)
      this.getDishList()
    },

    getTagClass: (tagName) => {
      const tagClasses = {
        '推荐': 'tag-signature',
        '热销': 'tag-hot',
        '限时特价': 'tag-discount',
        '麻辣': 'tag-spicy',
        '下饭菜': 'tag-rice',
        '经典': 'tag-classic'
      }
      return tagClasses[tagName] || 'tag-default'
    }
  },
});